import { createApp } from 'vue';
import App from '../App.vue';
import Vidle from 'v-idle-3';

const app = createApp(App);
app.use(Vidle);

export default app;
